import React from 'react';
import Moment from 'react-moment';

const ResultListingBody = ({test}) => {

    return(
        <>
            <div className='border-l-steal-c-100 border-l-4'>
                {test?.Result?.id ?
                    <div className="flex items-center bg-slate-100 p-2 gap-x-4 justify-between">
                        <p className="w-2/5">
                            Result
                        </p>
                        <p className="w-3/5">
                            Result Date
                        </p>
                    </div>
                    :
                    <div className="flex flex-row items-center bg-slate-100 px-2 py-2 gap-x-8">
                        <p className="w-full text-center">
                            No Results found.
                        </p>
                    </div>
                }
            </div>
            {test?.Result?.id ?
                <div className={`divide-y divide-gray-200 bg-white alternative-color font-light`}>
                    <div className={`border-b-2 flex items-center p-2 gap-x-4 justify-between`} style={{borderLeft: '4px solid #cdd7e1'}}>
                        <div className="w-2/5">
                            {test.Result?.result ? test.Result?.result : '-'}
                        </div>
                        <p className="w-3/5">
                            <Moment format="MM/DD/YYYY">
                                {test.Result?.result_date}
                            </Moment>
                        </p>
                    </div>
                </div>
                : null
            }
        </>
    )
}

export default ResultListingBody;